import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

function regularPopup(){
	const popups = document.querySelectorAll('[data-name="popup"]');

	if (popups.length > 0) {
		popups.forEach((popup) => {
			popup.addEventListener("click", (e) => {
				e.preventDefault();

				const src = popup.getAttribute("href") || popup.dataset.src;

				Fancybox.show(
					[ {
						src: src,
						type: "inline",
					} ],
					{
						Carousel: {
							Navigation: false,
						},
						tpl: {
							closeButton: `
							<button data-fancybox-close class="f-button is-close-btn" title="Close" style="width: 50px; height: 50px; padding: 0; display: flex; align-items: center; justify-content: center;">
							<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 57 57" fill="none" style="max-width: 100%; max-height: 100%;">
								<circle cx="28.285" cy="28.284" r="19.5" stroke="#152A51" transform="rotate(45 28.285 28.284)"/>
								<path fill="#152A51" fill-rule="evenodd" d="M22.628 22.628a1 1 0 0 1 1.414 0l9.9 9.9a1 1 0 1 1-1.415 1.414l-9.9-9.9a1 1 0 0 1 0-1.414Z" clip-rule="evenodd"/>
								<path fill="#152A51" fill-rule="evenodd" d="M33.94 22.628a1 1 0 0 1 0 1.414l-9.899 9.9a1 1 0 0 1-1.414-1.415l9.9-9.9a1 1 0 0 1 1.414 0Z" clip-rule="evenodd"/>
							</svg>
							</button>
							`
						}
					}
				);
			});
		});
	}


}

function popups(){
	// Generic
	Fancybox.bind("[data-fancybox]", {
		Thumbs: false,
	});

	regularPopup()
}

export default popups;
